import React, { useState, useEffect, useMemo } from "react";
import {
  Add_TestSettings,
  Get_Categorry,
  Get_SubCategory,
  GetDataBySearch,
  ToggleFavoriteCategory,
  ToggleFavoriteSubCategory,
  ToggleFavoriteTest,
} from "../Services/TestServices";
import { toast } from "react-toastify";
import { Button } from "@mui/material";
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import StarBorderRoundedIcon from '@mui/icons-material/StarBorderRounded';
import { useApi } from "../ContextApi/ContextApi";
import '../UI/TestSettings.css';

const TestSettings = ({ onSaved }) => {
  const { setTest_SubmissionStatus } = useApi();
  const LabID = sessionStorage.getItem('LabID');
  const [formData, setFormData] = useState({
    CataGory_Value: '',
    sub_Categorry: '',
    Age_Value: '',
    StaticResult: '',
    LabID: sessionStorage.getItem('LabID'),
  });

  // ----------- Favorite tags (Category / Sub Category / Test) -----------
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [tests, setTests] = useState([]);
  const [testFilter, setTestFilter] = useState('');

  const loadFavoriteLists = async () => {
    try {
      const [categoryList, subCategoryList, testList] = await Promise.all([
        Get_Categorry(LabID),
        Get_SubCategory(LabID),
        GetDataBySearch({ LabID }),
      ]);
      setCategories(categoryList || []);
      setSubCategories(subCategoryList || []);
      setTests(testList || []);
    } catch (error) {
      console.error("Error fetching favorite lists:", error);
    }
  };

  useEffect(() => {
    loadFavoriteLists();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggleCategoryFavorite = async (item) => {
    const nextValue = !item.isFavorite;
    setCategories((prev) =>
      prev.map((c) => (c.categorY_CODE === item.categorY_CODE ? { ...c, isFavorite: nextValue } : c))
    );
    try {
      await ToggleFavoriteCategory(LabID, item.categorY_CODE, nextValue);
      toast.success(nextValue ? "Added to favorites" : "Removed from favorites");
    } catch (error) {
      toast.error("Failed to update favorite");
      setCategories((prev) =>
        prev.map((c) => (c.categorY_CODE === item.categorY_CODE ? { ...c, isFavorite: !nextValue } : c))
      );
    }
  };

  const toggleSubCategoryFavorite = async (item) => {
    const nextValue = !item.isFavorite;
    setSubCategories((prev) =>
      prev.map((s) => (s.suB_CATEGORY_CODE === item.suB_CATEGORY_CODE ? { ...s, isFavorite: nextValue } : s))
    );
    try {
      await ToggleFavoriteSubCategory(LabID, item.suB_CATEGORY_CODE, nextValue);
      toast.success(nextValue ? "Added to favorites" : "Removed from favorites");
    } catch (error) {
      toast.error("Failed to update favorite");
      setSubCategories((prev) =>
        prev.map((s) => (s.suB_CATEGORY_CODE === item.suB_CATEGORY_CODE ? { ...s, isFavorite: !nextValue } : s))
      );
    }
  };

  const toggleTestFavorite = async (item) => {
    const nextValue = !item.isFavorite;
    setTests((prev) =>
      prev.map((t) => (t.testID === item.testID ? { ...t, isFavorite: nextValue } : t))
    );
    try {
      await ToggleFavoriteTest(LabID, item.testID, nextValue);
      toast.success(nextValue ? "Added to favorites" : "Removed from favorites");
    } catch (error) {
      toast.error("Failed to update favorite");
      setTests((prev) =>
        prev.map((t) => (t.testID === item.testID ? { ...t, isFavorite: !nextValue } : t))
      );
    }
  };

  const filteredTests = useMemo(() => {
    const query = testFilter.trim().toLowerCase();
    if (!query) return tests;
    return tests.filter((t) => t.testName?.toLowerCase().includes(query));
  }, [tests, testFilter]);
  // ----------- END Favorite tags -----------

  const onChange = (e) => {
    const { value, name } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

 

 

  const save = async (e) => {
    e.preventDefault();
    try {
      if(formData.Age_Value == "" && formData.CataGory_Value=="" && formData.sub_Categorry == "" && formData.StaticResult =="")
      {
          toast.info("boxes are empty")
      }else if (formData.StaticResult.toLowerCase() === 'nill' ||  formData.StaticResult.toLowerCase() === 'positive' ||  formData.StaticResult.toLowerCase() === 'negative'){
        toast.info("these Results Already Added")
      }else{
        const response = await Add_TestSettings(formData);
        if (response) {
          toast.success("Data saved successfully");
          loadFavoriteLists();
          setTest_SubmissionStatus(true);
          if (onSaved) onSaved();
        } else {
          toast.error("Something went wrong");
        }
      }
     
    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <>
      <div className="container-fluid" style={{ width: '100%',border:'1px solid lightgray',padding:'20px' }}>
      <h5 className="common-FontSize-small common-FontFamil">Note:You can add values individually, one at a time .</h5>
        <hr></hr>
        <div className="row">
          <div className='col-sm-4'>
            <label className='common-Labels' htmlFor="CataGory_Value">Category Value:</label>
          </div>
           <div className="col-sm-6">  
            <input
              className="form-control form-control common-Input"
              id='CataGory_Value'
              name='CataGory_Value'
              value={formData.CataGory_Value}
              onChange={onChange}
            />
          </div>
        </div>
        <div className="row">
          <div className='col-sm-4'>
            <label className='common-Labels' htmlFor="sub_Categorry">Sub Category:</label>
          </div>
          <div className="col-sm-6 mt-2"> 
            <input
              className="form-control form-control common-Input"
              id='sub_Categorry'
              name='sub_Categorry'
              value={formData.sub_Categorry}
              onChange={onChange}
            />
          </div>
          <div className='col-sm-4 mt-2'>
            <label className='common-Labels' htmlFor="Age_Value">Age Value:</label>
          </div>
          <div className="col-sm-6 mt-2">
             <input
              className="form-control form-control common-Input"
              id='Age_Value'
              name='Age_Value'
              value={formData.Age_Value}
              onChange={onChange}
            />
          </div>
        </div>
        <div className="row">
        <div className='col-sm-4 mt-2'>
            <label className='common-Labels' htmlFor="StaticResult">Result Suggestion:</label>
          </div>
          <div className="col-sm-6 mt-2">
             <input
              className="form-control form-control common-Input"
              id='StaticResult'
              name='StaticResult'
              value={formData.StaticResult}
              onChange={onChange}
            />
          </div>
        </div>
        <div className="row">
          <div className='col-sm-3 mt-4'>
            <Button onClick={save}   variant="contained"  className="common-button">Save</Button>
          </div>
        </div>

        <hr className="mt-4"></hr>
        <h5 className="common-FontSize-small common-FontFamil">Mark Favorites: shown as quick tags on the Lab Order search screen.</h5>

        <div className="row mt-2">
          <div className='col-sm-6'>
            <label className='common-Labels'>Main Categories</label>
            <div className="favorite-list-box">
              {categories.length === 0 && (
                <div className="common-FontSize-small text-muted p-2">No categories yet</div>
              )}
              {categories.map((item) => (
                <div key={item.categorY_CODE} className="favorite-list-row">
                  <span className="common-FontSize-small">{item.categorY_VALUE}</span>
                  <button
                    type="button"
                    className="favorite-star-button"
                    onClick={() => toggleCategoryFavorite(item)}
                    title={item.isFavorite ? "Remove from favorites" : "Mark as favorite"}
                  >
                    {item.isFavorite ? (
                      <StarRoundedIcon style={{ color: '#f5b301' }} />
                    ) : (
                      <StarBorderRoundedIcon style={{ color: '#999' }} />
                    )}
                  </button>
                </div>
              ))}
            </div>
          </div>

          <div className='col-sm-6'>
            <label className='common-Labels'>Sub Categories</label>
            <div className="favorite-list-box">
              {subCategories.length === 0 && (
                <div className="common-FontSize-small text-muted p-2">No sub categories yet</div>
              )}
              {subCategories.map((item) => (
                <div key={item.suB_CATEGORY_CODE} className="favorite-list-row">
                  <span className="common-FontSize-small">{item.suB_CATEGORY_VALUE}</span>
                  <button
                    type="button"
                    className="favorite-star-button"
                    onClick={() => toggleSubCategoryFavorite(item)}
                    title={item.isFavorite ? "Remove from favorites" : "Mark as favorite"}
                  >
                    {item.isFavorite ? (
                      <StarRoundedIcon style={{ color: '#f5b301' }} />
                    ) : (
                      <StarBorderRoundedIcon style={{ color: '#999' }} />
                    )}
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-sm-12">
            <label className='common-Labels'>Tests</label>
            <input
              className="form-control form-control common-Input mb-2"
              placeholder="Filter tests..."
              value={testFilter}
              onChange={(e) => setTestFilter(e.target.value)}
            />
            <div className="favorite-list-box favorite-list-box-tall">
              {filteredTests.length === 0 && (
                <div className="common-FontSize-small text-muted p-2">No tests found</div>
              )}
              {filteredTests.map((item) => (
                <div key={item.testID} className="favorite-list-row">
                  <span className="common-FontSize-small">
                    {item.testName}
                    {(item.categorY_VALUE || item.suB_CATEGORY_VALUE) && (
                      <span className="text-muted">
                        {" "}({item.categorY_VALUE}{item.suB_CATEGORY_VALUE ? ` / ${item.suB_CATEGORY_VALUE}` : ''})
                      </span>
                    )}
                  </span>
                  <button
                    type="button"
                    className="favorite-star-button"
                    onClick={() => toggleTestFavorite(item)}
                    title={item.isFavorite ? "Remove from favorites" : "Mark as favorite"}
                  >
                    {item.isFavorite ? (
                      <StarRoundedIcon style={{ color: '#f5b301' }} />
                    ) : (
                      <StarBorderRoundedIcon style={{ color: '#999' }} />
                    )}
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TestSettings;
